<template>
  <div class="CadastroConfigComissao">
    <el-table :data="list" empty-text="Sem dados!">
       <el-table-column
        prop="name"
        label="Tipo"
        width="180" >
      </el-table-column>
      <el-table-column label="Valor" width="150" >
        <template slot-scope="scope">
          <money  v-model="list[scope.$index].valor" v-bind="percentual" class="el-input el-input__inner"></money> 
        </template>
      </el-table-column>
      <el-table-column v-if="permissao.editar_configuracoes" label="Ação" >
        <template slot-scope="scope">
          <el-button  size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">Salvar</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import axios from 'axios';
import FuncoesUteis from "../../plugins/FuncoesUteis";
import  {Money}  from "v-money";

// const url = 'http://'+window.location.hostname+':8000/api';
const url = '/api';

    export default {
        components: {
    Money,
  },
    data(){
      return {
      percentual: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        suffix: " %",
        masked: false /* doesn't work with directive */,
      }, 
       labelPosition: 'right',
       list:[],
       permissao: {},
       dialogFormVisibleComissao: false,
      }
    },
   mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_configuracoes) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    axios
      .get(url + "/config/", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
         this.list = response.data;
         //feita manualmente porque com o for abaixo comentado não funciona
          this.list.splice(6,1);
          this.list.splice(5,1);
          this.list.splice(4,1);
          this.list.splice(2,1);
          this.list.splice(1,1);
          this.list.splice(0,1);
        
          //  let tam = response.data.length;
         //let x = 0;
        //for(let y=0; y<tam;y++){
       //    if(response.data[y].id==9 || response.data[y].id == 5){
           //  this.list[x] = response.data[y];
            //  x++;
         //  } 
        }
      })
      .catch((err) => {
        this.total = "erro" + err;
      });
   },

     methods: {
    //FIM CADASTRO DADOS
    handleEdit(index, row) {
      let id = row.id;
          let dados = {
            valor: row.valor,
          };
          axios
            .put(url + "/config/" + id, dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro Alterado com sucesso!",
                type: "success",
              });
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });      
    },
  },
    //     methods:{
    //  //CADASTRO DADOS
    //    handleFecharComissao(){
    //      this.$confirm('Tem certeza que deseja sair?', 'Aviso', {
    //       confirmButtonText: 'Sim',
    //       cancelButtonText: 'Não',
    //       type: 'warning'
    //     }).then(() => {
    //       this.dialogFormVisibleComissao = false;
    //       this.ruleForm.valor='';
    //     }).catch(() => {
    //       this.dialogFormVisibleComissao = true;
    //     });
    //   },
    //   submitFormComissao(formName) {
    //     this.$refs[formName].validate((valid) => {
    //       if (valid) {
    //                         let vl;
    //            vl = this.ruleForm.valor;
    //            vl = vl.replace('.','');
    //            this.ruleForm.valor = vl.replace(',','.');
    //         let dados = {
    //           valor:  this.ruleForm.valor,
    //         }
    //     axios
    //       .post(url+'/config_comissao/',
    //       dados,
    //       {  headers: {
    //         'Authorization': 'Bearer ' + this.$store.state.token
    //         }
    //       }
    //       )
    //       .then(() => {  
    //               this.$notify({
    //                 title: 'Sucesso',
    //                 message: 'Registro Salvo com sucesso!',
    //                 type: 'success'
    //               });
    //               this.dialogFormVisibleComissao = false;
    //               this.ruleForm.valor='';
    //               this.$emit('dadosComissao-click');
    //           })
    //       .catch(err => {
    //               this.$notify({
    //                 title: 'Erro',
    //                 message: 'Erro ao cadastrar os dados! Tente novamente mais tarde!'+err,
    //                 type: 'error'
    //               });
    //               this.dialogFormVisibleComissao = false;
    //               this.ruleForm.valor='';
    //           });        
    //       } else {
    //           this.$message({
    //                 type: 'info',
    //                 message: 'Informe os dados corretamente!'
    //           });
    //         return false;
    //       }
    //     });
    //   },          
      //FIM CADASTRO DADOS

        // }
    }

</script>